import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class UrlUtil {

    formatURlParams(url: string, params: any): string {
        for (const key of Object.keys(params)) {
            url = url.replace(`{${key}}`, params[key]);
        }
        return url;
    }

    // Looks up a query param by name ignoring case, e.g. affiliationcode vs affiliationCode.
    getQueryParamCaseInsensitive(params: any, paramName: string): string {
        if (!params) {
            return '';
        }
        const matchedKey = Object.keys(params).find(
            key => key.toLowerCase() === paramName.toLowerCase()
        );
        return matchedKey ? (params[matchedKey] || '').toString().toLowerCase() : '';
    }

    getNoCacheHeaders(): any {
        const headers = new HttpHeaders({
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        });
        return { headers };
    }

    isMobileUserAgent(): boolean {
        return ((navigator.userAgent.match(/Android/i) != null) ||
            (navigator.userAgent.match(/webOS/i) != null) ||
            (navigator.userAgent.match(/iPhone/i) != null) ||
            (navigator.userAgent.match(/iPad/i) != null) ||
            (navigator.userAgent.match(/BlackBerry/i) != null) ||
            (navigator.userAgent.match(/Windows Phone/i) != null) ||
            (navigator.userAgent.match(/IEMobile/i) != null) ||
            (navigator.userAgent.match(/Opera Mini/i) != null) ||
            (navigator.userAgent.match(/Mobile/i) != null) ||
            (navigator.userAgent.match(/CriOS/i) != null)
        );
    }

    isAppStoreUserAgent(): boolean {
        return ((navigator.userAgent.match(/iPhone/i) != null) ||
            (navigator.userAgent.match(/iPad/i) != null) ||
            (navigator.userAgent.match(/iPod/i) != null) || this.isIPadProUserAgent());
    }

    isIPadProUserAgent(): boolean {
        return (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/i.test(navigator.platform));
    }
}
